module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--sp-7737a649483123a176dd90fd17923bba.webp";